import { NgComponentOutlet } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { PadraoHomepageService } from '../../services/padrao-homepage.service';
import { SecaoHomepageId, ordenarSecoesHomepage } from './secoes-homepage.model';

/**
 * Renderiza as seções da homepage na ordem que o órgão publica no adm, sem as que ele ocultou.
 *
 * Header e rodapé não passam por aqui: ficam no `MainLayoutComponent` e não são ordenáveis.
 * Para incluir uma seção nova, basta acrescentá-la a `SECOES_HOMEPAGE` — ela entra no fim
 * da homepage até o adm conhecer o bloco (a lista dele é própria) e a API devolvê-lo.
 */
@Component({
  selector: 'app-secoes-homepage',
  imports: [NgComponentOutlet],
  template: `
    <div class="content-box">
      @for (secao of secoes(); track secao.id) {
        <ng-container [ngComponentOutlet]="secao.componente"></ng-container>
      }
    </div>
  `,
})
export class SecoesHomepageComponent {
  private readonly padrao = inject(PadraoHomepageService);

  /**
   * Ordem avulsa, para a tela do adm pré-visualizar um arranjo antes de salvar.
   * Sem valor, vale o padrão que o órgão publica.
   */
  readonly ordem = input<readonly SecaoHomepageId[] | null>(null);

  readonly secoes = computed(() => {
    const previa = this.ordem();
    return previa ? ordenarSecoesHomepage(previa) : this.padrao.secoes();
  });
}
